module.exports = __webpack_public_path__ + "static/media/home-banner-video.8da769c3.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./src/video/home-banner-video.mp4
 ** module id = 701
 ** module chunks = 0
 **/